// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"54be64c4","453":"80743573","467":"f8669765"}[chunkId] + ".chunk.js";
};